import { useRef, useState } from 'react'
import { IMedia } from '../../mediaPreview.types.ts'
import css from './video.module.css'
import PlayIcon from '../../../../assets/icons/icon-play.svg?react'

const Video = (props: IMedia) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  return (
    <div className={css.wrapper}>
      {!isPlaying && (
        <button
          className={css.playButton}
          onClick={() => {
            if (videoRef.current) {
              videoRef.current.play()
              videoRef.current.controls = true
              setIsPlaying(true)
            }
          }}
        >
          <PlayIcon className={css.playIcon} />
        </button>
      )}
      <video width="400" preload="metadata" autoPlay={false} ref={videoRef}>
        <source src={props.url} />
      </video>
    </div>
  )
}

export default Video
